import { type FC } from 'react'

import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { recommendationAccessorGetProductDiscount } from '../../model/recommendationAccessorGetProductDiscount'

type RecommendationProductImageDiscountProps = {
  product: GkAirRecommendedProductDataWeb
}

export const RecommendationProductImageDiscount: FC<
  RecommendationProductImageDiscountProps
> = ({ product }) => {
  const discount = recommendationAccessorGetProductDiscount(product)

  if (!discount) {
    return null
  }

  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
    <span className="absolute right-2.5 top-3.5 block aspect-square w-12 rounded-full bg-light-tertiary text-center font-mono leading-[48px] text-dark-primary-max">
      {discount}
    </span>
  )
}
